import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { siteInfo } from '@/mocks/siteInfo';
import { reviews } from '@/mocks/reviews';
import { Link } from 'react-router-dom';

export default function AboutPage() {
  return (
    <>
      <Navbar />
      <main className="bg-background-50">
        {/* Hero Header */}
        <section className="pt-16 min-h-[240px] md:min-h-[300px] flex items-center bg-background-100 border-b border-background-200">
          <div className="px-4 md:px-6 w-full max-w-4xl mx-auto">
            <nav className="text-sm text-foreground-500 mb-6">
              <span className="text-foreground-400">首页</span>
              <i className="ri-arrow-right-s-line mx-1 text-foreground-300"></i>
              <span className="text-foreground-900 font-medium">关于我们</span>
            </nav>
            <h1 className="text-3xl md:text-5xl font-bold font-heading text-foreground-900 mb-3">
              关于 {siteInfo.logo}
            </h1>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl">
              吃瓜黑料第一站，全网最真实、最及时的爆料资讯聚合平台
            </p>
          </div>
        </section>

        {/* Brand Introduction */}
        <section className="py-12 md:py-20 px-4 md:px-6">
          <div className="max-w-4xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
              <div>
                <span className="text-xs text-foreground-400 tracking-widest uppercase mb-3 block">品牌介绍</span>
                <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-5 leading-snug">
                  全网爆料，<span className="text-primary-600">真实</span>第一
                </h2>
                <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                  <p>
                    {siteInfo.name} 成立于2023年，是国内领先的娱乐爆料资讯聚合平台。我们致力于为广大吃瓜群众提供<strong className="text-foreground-900">最真实、最及时、最全面</strong>的网红翻车、明星八卦、综艺内幕等热门爆料内容。
                  </p>
                  <p>
                    我们的编辑团队24小时轮班值守，全网实时监控社交媒体、论坛、直播间等渠道，确保每一条爆料都能第一时间推送到你眼前。截至目前，平台已累计发布爆料资讯超过<strong className="text-foreground-900">10,000+</strong>条，服务吃瓜用户超过<strong className="text-foreground-900">500万</strong>人次。
                  </p>
                  <p>
                    我们始终坚持"真实第一"的原则，所有爆料内容均经过多方核实，拒绝编造、拒绝造谣，让每一位用户都能在这里吃到<strong className="text-foreground-900">保真的瓜</strong>。
                  </p>
                </div>
              </div>
              <div className="rounded-2xl overflow-hidden aspect-[4/3]">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20modern%20editorial%20workspace%20scene%20with%20warm%20amber%20and%20charcoal%20tones%2C%20multiple%20screens%20showing%20social%20media%20feeds%2C%20dramatic%20cinematic%20lighting%2C%20abstract%20luxury%20interior%2C%20no%20people%2C%20high%20contrast%2C%20warm%20neutral%20palette&width=800&height=600&seq=about-brand-911-2026&orientation=landscape"
                  alt="911爆料网编辑团队"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Stats */}
        <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100 border-y border-background-200">
          <div className="max-w-4xl mx-auto">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
              <div className="text-center">
                <p className="text-3xl md:text-4xl font-bold font-heading text-primary-600 mb-1">500万+</p>
                <p className="text-sm text-foreground-500">累计用户</p>
              </div>
              <div className="text-center">
                <p className="text-3xl md:text-4xl font-bold font-heading text-accent-600 mb-1">10,000+</p>
                <p className="text-sm text-foreground-500">爆料文章</p>
              </div>
              <div className="text-center">
                <p className="text-3xl md:text-4xl font-bold font-heading text-secondary-600 mb-1">6</p>
                <p className="text-sm text-foreground-500">热门频道</p>
              </div>
              <div className="text-center">
                <p className="text-3xl md:text-4xl font-bold font-heading text-primary-600 mb-1">24h</p>
                <p className="text-sm text-foreground-500">实时更新</p>
              </div>
            </div>
          </div>
        </section>

        {/* Reputation / User Reviews */}
        <section className="py-12 md:py-20 px-4 md:px-6">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-10 md:mb-14">
              <span className="text-xs text-foreground-400 tracking-widest uppercase mb-2 block">口碑声誉</span>
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
                吃瓜群众怎么说
              </h2>
              <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
                真实用户评价，口碑是我们最看重的资产
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
              {reviews.map((review) => (
                <div key={review.id} className="p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/70">
                  <div className="flex items-center gap-3 mb-4">
                    <img
                      src={review.avatar}
                      alt={review.userName}
                      className="w-11 h-11 rounded-full object-cover"
                      loading="lazy"
                    />
                    <div>
                      <p className="text-sm font-semibold text-foreground-900">{review.userName}</p>
                      <div className="flex items-center gap-1">
                        {[...Array(5)].map((_, i) => (
                          <i
                            key={i}
                            className={`text-xs ${
                              i < Math.floor(review.rating)
                                ? 'ri-star-fill text-accent-500'
                                : 'ri-star-line text-foreground-300'
                            }`}
                          ></i>
                        ))}
                        <span className="text-xs text-foreground-400 ml-1">{review.rating}</span>
                      </div>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">
                    &ldquo;{review.content}&rdquo;
                  </p>
                  <p className="text-xs text-foreground-400 mt-3">{review.date}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact Info */}
        <section className="py-12 md:py-20 px-4 md:px-6 bg-background-100 border-t border-background-200">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-10 md:mb-14">
              <span className="text-xs text-foreground-400 tracking-widest uppercase mb-2 block">联系我们</span>
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
                爆料投稿与合作
              </h2>
              <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
                有独家猛料？欢迎联系投稿。商务合作也请随时沟通。
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
              <div className="p-6 rounded-xl bg-background-50 border border-background-200/70 text-center">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mx-auto mb-4">
                  <i className="ri-mail-line text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-2">投稿邮箱</h3>
                <p className="text-sm text-foreground-600">{siteInfo.email}</p>
                <p className="text-xs text-foreground-400 mt-2">24小时内回复</p>
              </div>

              <div className="p-6 rounded-xl bg-background-50 border border-background-200/70 text-center">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto mb-4">
                  <i className="ri-wechat-line text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-2">微信公众号</h3>
                <p className="text-sm text-foreground-600">{siteInfo.wechat}</p>
                <p className="text-xs text-foreground-400 mt-2">扫码关注获取推送</p>
              </div>

              <div className="p-6 rounded-xl bg-background-50 border border-background-200/70 text-center">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 mx-auto mb-4">
                  <i className="ri-weibo-line text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-2">官方微博</h3>
                <p className="text-sm text-foreground-600">{siteInfo.weibo}</p>
                <p className="text-xs text-foreground-400 mt-2">实时同步热门爆料</p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-10 md:mt-14 text-center">
              <p className="text-sm text-foreground-500 mb-4">投稿须知：请附上相关截图、视频或链接，我们承诺保护爆料人隐私</p>
              <Link
                to="/"
                className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-foreground-900 text-background-50 text-sm font-medium hover:bg-foreground-800 transition-all duration-300 hover:scale-105"
              >
                返回首页吃瓜 <i className="ri-arrow-right-up-line"></i>
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: `关于${siteInfo.name}`,
            description: siteInfo.description,
            url: 'https://4xhyp.com/about',
            mainEntity: {
              '@type': 'Organization',
              name: siteInfo.name,
              alternateName: siteInfo.logo,
              description: siteInfo.description,
              email: siteInfo.email,
              url: 'https://4xhyp.com/',
              sameAs: [
                `https://weibo.com/${siteInfo.weibo}`,
              ],
            },
          }),
        }}
      />
    </>
  );
}
